import { Http } from 'packages/workspace/modules/prelude/http';
import { FETCH_ACCOUNT, fetchAccount } from 'packages/workspace/services/fetchers/fetch-accounts';
import { UseMutationResult, UseQueryResult, useMutation, useQuery } from 'react-query';
import type { IAccount } from '../models/account';
import { ResponseFormat } from '../models/global-models';

export default function useAccount(accountId: string): UseQueryResult<Array<IAccount>> {
  return useQuery([FETCH_ACCOUNT, accountId], () => fetchAccount(accountId));
}

export function useUpdateAccount(): UseMutationResult<IAccount, unknown, IAccount, unknown> {
  return useMutation((updateData: IAccount) => Http.Request<IAccount>('PUT', '/workspaces/api/v1/accounts.update', updateData));
}

export function useAddAccount(): UseMutationResult<IAccount, unknown, IAccount, unknown> {
  return useMutation((createData: IAccount) => Http.Request<IAccount>('POST', '/workspaces/api/v1/accounts.create', createData));
}

export function useDeleteAccount(): UseMutationResult<IAccount, unknown, string, unknown> {
  return useMutation((id: string) => Http.Request<IAccount>('DELETE', `/workspaces/api/v1/accounts.remove?id=${id}`));
}

export function useDeleteAccountIp(): UseMutationResult<string, unknown, { ipId: string, accountId: string }, unknown> {
  return useMutation(async ({ ipId, accountId }) => Http.Request<Record<string, string>>('DELETE', `/workspaces/api/v1/account/device.delete?ip=${ipId}&accountId=${accountId}`));
}

export function useAddMember(): UseMutationResult<IAccount, unknown, string, unknown> {
  return useMutation((id: string) => Http.Request<IAccount>('POST', '/workspaces/api/v1/workspace-members.add', [id]));
}

export function useSendPassword(): UseMutationResult<string, unknown, string, unknown> {
  return useMutation((id: string) => Http.Request<string>('PUT', `/workspaces/api/v1/accounts.resendEmail?id=${id}`));
}

export function useVerifyOTP(): UseMutationResult<ResponseFormat<string>, unknown, { otp: string }, unknown> {
  return useMutation((params: { otp: string }) => Http.Request<ResponseFormat<string>>('POST', `/workspaces/api/v1/account/device.verify`, params));
}